import UnitComponent from './component'
export default UnitComponent
